import { NETFLIX_PO } from "../catalogConstants";

export const PRODUCT_OFFERING_TYPES = {
  PACK: ['1', '2'],
  INCLUDED_R2R: ['11'],
  ADDITIONAL_R2R: ['10'],
  ADDITIONAL_MOBILE: ['21'],
  VTL: ['24'],
  MOBILE: ['4'],
  LAND_LINE: ['5'],
  BAF: ['12', '135'],
  ISR: ['3', '33'],
  PREPAID: ['6'],
  GAME_PASS: ['23'],
  HEALTH: ['13'],
  TV: ['7'],
  NETFLIX: ['8'],
  DISNEY: ['9'],
  MULTI_SIM: ['35'],
  MOBILE_INSURANCE: ['186'],
  SWAP: ['201', '202', '203'],
};

export const ALWAYS_NEW_PRODUCT_OFFERING_TYPE = '201';

export const CLIENT_TYPES = {
  PACK: 'PACK',
  CONVERGENT: 'CONVERGENT',
  ONLY_MOBILE: 'ONLY_MOBILE',
  ONLY_LANDLINE: 'ONLY_LANDLINE',
  STANDALONE: 'STANDALONE',
};

export const PRODUCT_TYPES = {
  PACK: 'PACK',
  INCLUDED_R2R: 'INCLUDED_R2R',
  ADDITIONAL_R2R: 'ADDITIONAL_R2R',
  ADDITIONAL_MOBILE: 'ADDITIONAL_MOBILE',
  VTL: 'VTL',
  MOBILE: 'MOBILE',
  LAND_LINE: 'LAND_LINE',
  BAF: 'BAF',
  ISR: 'ISR',
  PREPAID: 'PREPAID',
  GAME_PASS: 'GAME_PASS',
  HEALTH: 'HEALTH',
  OTHER: 'OTHER',
  TV: 'TV',
  NETFLIX: 'NETFLIX',
  CAR: 'CAR',
  MULTI_SIM: 'MULTI_SIM',
  E_SIM: 'E_SIM',
  MOBILE_INSURANCE: 'MOBILE_INSURANCE',
};

export const MANUAL_PRODUCT_TYPES_MAPPING = {
  miMovistar: PRODUCT_TYPES.PACK,
  baf: PRODUCT_TYPES.BAF,
  prepaid: PRODUCT_TYPES.PREPAID,
  car: PRODUCT_TYPES.CAR,
  multiSim: PRODUCT_TYPES.MULTI_SIM,
  r2rRenewal: PRODUCT_TYPES.INCLUDED_R2R,
}

export const DEVICE_VALUES = {
  INCLUDED: 'incluido',
  ADDITIONAL: 'adicional',
};

export const areThereProductOfferingTypesIntoOfferArray = (offerProductOfferingTypes, productOfferingTypesToTest) => {
  if (offerProductOfferingTypes.some(element => productOfferingTypesToTest.includes(element.id))) {
    return true;
  }

  return false;
};

export const getProductTypeByProductOfferingTypes = (productOfferingTypes) => {
  let productType = PRODUCT_TYPES.OTHER;

  Object.keys(PRODUCT_OFFERING_TYPES).some((key) => {
    const productTypeToTest = PRODUCT_OFFERING_TYPES[key];

    if (productOfferingTypes.some(element => productTypeToTest.includes(element.id))) {
      productType = key;
    }
    return productType !== PRODUCT_TYPES.OTHER;
  });

  return productType;
};

export const getProductTypesArrayByProductOfferingTypesArray = (productOfferingTypesArray) => {
  const productTypes = [];

  productOfferingTypesArray.forEach(productOfferingTypes => {
    const productType = getProductTypeByProductOfferingTypes(productOfferingTypes);

    productTypes.push(productType);
  });

  return productTypes;
}

export const detectNetflixPOatDisagregate = (disagregateResponse) => {
  const { productOfferings } = disagregateResponse;
  if (productOfferings && Array.isArray(productOfferings)) {
    const netflixPOInfo = productOfferings.find(poInfo => poInfo.id === NETFLIX_PO);

    if (netflixPOInfo) {
      return true;
    }
  }

  return false;
};
